import { EntityBase } from 'projects/sepidz-web-framework/src/lib/models/entity-base.model';
import { ItemDetailsOrder } from './ItemDetailsOrder.model';
import { Additive } from '../../catalog/model/additive.model';
import { Description } from '../../catalog/model/description.model';

export class ItemOrder extends EntityBase {
  public Code: string;
  public CategoryTitle: string;
  public Title: string;
  public UnitPrice: number;
  public MeasurementUnit: string;
  public ApplyTax?: boolean;
  public ApplyService?: boolean;
  public Additive: Additive[];
  public Desctiption: Description[];
  public ItemDetailsOrders: ItemDetailsOrder[];
  constructor() {
    super();
    this.Code = '';
    this.CategoryTitle = '';
    this.Title = '';
    this.UnitPrice = 0;
    this.MeasurementUnit = '';
    this.ApplyTax = false;
    this.ApplyService = false;
    this.Additive = [];
    this.Desctiption = [];
    this.ItemDetailsOrders = [];
  }
}
export enum ItemDependencyType {
  Free = 1,
  Related = 2,
}


export enum UnitKindEnum {
   NormalItem,
   PosScaleItem,
}